export default [
    {
        path: "/requisition/approved-budget",
        name: "approved-budget",
        meta: {title: "approved-budget", authRequired: true},
        component: () => import("../views/requisition/approved-app.vue"),
    },
    {
        path: "/requisition/create",
        name: "create-requisition",
        meta: {title: "create-requisition", authRequired: true},
        component: () => import("../views/requisition/raise-requisition.vue"),
    },
    {
        path: "/requisition/requisition-review",
        name: "review-requisition",
        meta: {title: "Review Requisition", authRequired: true},
        component: () => import("../views/requisition/review-requisition.vue"),
    },
    {
        path: "/requisition/list",
        name: "list-requisitions",
        meta: {title: "list-requisitions", authRequired: true},
        component: () => import("../views/requisition/list-requisitions"),
    },
    {
        path: "/requisition/edit",
        name: "edit-requisition",
        meta: {title: "edit-requisition", authRequired: true},
        component: () => import("../views/requisition/edit-requisition.vue"),
    },
    {
        path: "/requisition/view",
        name: "view-requisition",
        meta: {title: "view-requisition", authRequired: true},
        component: () => import("../views/requisition/view-requisition"),
    },
    {
        path: "/requisition/pending-procurement",
        name: "pending-procurement",
        meta: {title: "Pending Procurements", authRequired: true},
        component: () => import("../views/requisition/list-pending-requisitions.vue"),
    },

]